/**
 * 任务进度计算。
 */

/**
 * 已完成占比,取整到整数百分比。
 *
 * 向下取整而非四舍五入:999/1000 四舍五入是 100%,但任务其实还没跑完,
 * 用户看到 100% 会以为已完成。宁可显示 99% 偏保守,也不给「假完成」。
 *
 * 同理,只要还差一个任务就不返回 100 —— 100% 只在真正全部完成时出现。
 */
export function completionPercent(completed: number, total: number): number {
  if (!total || total <= 0) return 0;
  if (completed >= total) return 100;
  return Math.min(99, Math.floor((completed / total) * 100));
}
